export const environment = {
    production: true,
    apiUrl: 'https://dev-api-gateway.madinaapps.com/',
    apiSecret: '%$K8WpJ8TDEm8Kom'
};
